import { Cell, Grid, HFlow, Icon, Text, VFlow } from 'bold-ui'
import { Color } from 'csstype'
import { GrupoImunobiologicoEnum, VacinaAplicadaCidadaoConsolidadoFragment } from 'graphql/types.generated'
import { useMemo } from 'react'

import { grupoImunobiologicoLabel } from '../../model/lista-tematica/model-acompanhamentoCondicaoSaudeListaTematica'
import { renderTextList } from './render-acompanhamentoCondicaoSaudeAccordion'
import { formatVacinasAplicadasCidadaoConsolidadoByGrupoImunobiologico } from './utils-acompanhamentoCondicaoSaudeAccordion'

interface AcompanhamentoCondicaoSaudeVacinasSectionProps {
  vacinas: ReadonlyArray<VacinaAplicadaCidadaoConsolidadoFragment>
  grupos: Set<GrupoImunobiologicoEnum>
  iconColor: Color
}

export function AcompanhamentoCondicaoSaudeVacinasSection({
  vacinas,
  grupos,
  iconColor,
}: Readonly<AcompanhamentoCondicaoSaudeVacinasSectionProps>) {
  const formattedVacinasByImunobiologicoGrupo = useMemo(
    () => formatVacinasAplicadasCidadaoConsolidadoByGrupoImunobiologico(vacinas),
    [vacinas]
  )

  return (
    <Grid gap={1} gapVertical={0.5} alignItems='baseline'>
      <Cell size={12}>
        <HFlow hSpacing={0.5} alignItems='center'>
          <Icon width='1rem' icon='needleFilled' color={iconColor} />
          <Text fontWeight='bold'>Vacinas</Text>
        </HFlow>
      </Cell>
      {Array.from(grupos).map((grupo) => {
        const formattedVacinas = formattedVacinasByImunobiologicoGrupo[grupo] ?? []

        return (
          <Cell size={6} key={grupo}>
            <VFlow vSpacing={0.25}>
              <Text fontWeight='bold'>{grupoImunobiologicoLabel[grupo]}</Text>
              {renderTextList(formattedVacinas)}
            </VFlow>
          </Cell>
        )
      })}
    </Grid>
  )
}
